// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var ImportEnrichmentRuleTypes$ReactHooksTemplate = require("./ImportEnrichmentRuleTypes.res.js");
var ImportEnrichmentActionHelpers$ReactHooksTemplate = require("./ImportEnrichmentActionHelpers.res.js");
var ImportEnrichmentRuleValidation$ReactHooksTemplate = require("./ImportEnrichmentRuleValidation.res.js");

function decodeObject(json) {
  return Belt_Option.getWithDefault(Js_json.decodeObject(json), {});
}

function getString(obj, key, defaultValue) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(obj, key), Js_json.decodeString), defaultValue);
}

function getBool(obj, key, defaultValue) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(obj, key), Js_json.decodeBoolean), defaultValue);
}

function parseConditionRow(json) {
  var obj = decodeObject(json);
  return {
          id: getString(obj, "id", ImportEnrichmentRuleTypes$ReactHooksTemplate.generateNodeId("c")),
          path: getString(obj, "path", "customer_details_data.source_type"),
          op: getString(obj, "op", "eq"),
          value: getString(obj, "value", ""),
          pattern: getString(obj, "pattern", ""),
          format: getString(obj, "format", "email"),
          caseSensitive: getBool(obj, "case_sensitive", true),
          regexMode: "Advanced",
          builderMatchType: "contains",
          builderText: ""
        };
}

function serializeLookupMap(value) {
  var mapDict = Belt_Option.flatMap(Js_dict.get(value, "map"), Js_json.decodeObject);
  if (mapDict !== undefined) {
    return Belt_Array.map(Js_dict.entries(mapDict), (function (param) {
                    var jsonValue = param[1];
                    var str = Js_json.decodeString(jsonValue);
                    var valueStr = str !== undefined ? str : Belt_Option.getWithDefault(JSON.stringify(jsonValue), "");
                    return param[0] + "=" + valueStr;
                  })).join("\n");
  } else {
    return "";
  }
}

function parseActionRow(json) {
  var obj = decodeObject(json);
  var target = decodeObject(Belt_Option.getWithDefault(Js_dict.get(obj, "target"), {}));
  var value = decodeObject(Belt_Option.getWithDefault(Js_dict.get(obj, "value"), {}));
  return {
          id: getString(obj, "id", ImportEnrichmentRuleTypes$ReactHooksTemplate.generateNodeId("a")),
          targetKind: getString(target, "kind", "column"),
          targetField: getString(target, "kind", "column") === "more_details" ? getString(target, "key", "") : getString(target, "name", ""),
          valueType: ImportEnrichmentRuleTypes$ReactHooksTemplate.valueTypeFromString(getString(value, "type", "literal")),
          valueLiteral: getString(value, "value", ""),
          copyPath: getString(value, "path", ""),
          lookupPath: getString(value, "path", ""),
          lookupMapText: serializeLookupMap(value),
          lookupDefault: getString(value, "default", ""),
          regexPath: getString(value, "path", ""),
          regexPattern: getString(value, "pattern", ""),
          regexGroup: getString(value, "group", "1"),
          regexCaseSensitive: getBool(value, "case_sensitive", true),
          regexMode: "Advanced",
          regexBuilderMatchType: "contains",
          regexBuilderText: "",
          fromPath: getString(value, "from", ""),
          toPath: getString(value, "to", ""),
          templateText: getString(value, "template", ""),
          onlyIfBlank: getBool(obj, "only_if_blank", false)
        };
}

function parseDefinitionForForm(definition) {
  var obj = decodeObject(definition);
  var whenObj = decodeObject(Belt_Option.getWithDefault(Js_dict.get(obj, "when"), {}));
  var match = Js_dict.get(whenObj, "all");
  var match$1 = Js_dict.get(whenObj, "any");
  var match$2;
  if (match !== undefined) {
    var rows = Belt_List.fromArray(Belt_Array.keepMap(Belt_Option.getWithDefault(Js_json.decodeArray(match), Caml_array.make(0, null)), parseConditionRow));
    match$2 = [
      "All",
      rows
    ];
  } else if (match$1 !== undefined) {
    var rows$1 = Belt_List.fromArray(Belt_Array.keepMap(Belt_Option.getWithDefault(Js_json.decodeArray(match$1), Caml_array.make(0, null)), parseConditionRow));
    match$2 = [
      "Any",
      rows$1
    ];
  } else {
    match$2 = [
      "All",
      /* [] */0
    ];
  }
  var parsedActions = Belt_List.fromArray(Belt_Array.keepMap(Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(obj, "actions"), Js_json.decodeArray), Caml_array.make(0, null)), parseActionRow));
  return [
          match$2[0],
          match$2[1],
          Belt_List.length(parsedActions) > 0 ? parsedActions : ({
                hd: ImportEnrichmentRuleTypes$ReactHooksTemplate.emptyAction(),
                tl: /* [] */0
              })
        ];
}

function parseLookupMap(mapText) {
  var dict = {};
  Belt_Array.forEach(mapText.split("\n"), (function (line) {
          var trimmed = line.trim();
          if (!(trimmed !== "" && trimmed.includes("="))) {
            return ;
          }
          var parts = trimmed.split("=");
          if (parts.length < 2) {
            return ;
          }
          var key = Caml_array.get(parts, 0).trim();
          var value = Caml_array.get(parts, 1).trim();
          dict[key] = value;
        }));
  return dict;
}

function encodeCondition(row) {
  var obj = {};
  obj["id"] = row.id;
  obj["path"] = row.path;
  obj["op"] = row.op;
  var match = row.op;
  switch (match) {
    case "matches_format" :
        obj["format"] = row.format;
        break;
    case "blank" :
    case "present" :
        break;
    case "regex_match" :
        obj["pattern"] = row.pattern;
        if (!row.caseSensitive) {
          obj["case_sensitive"] = false;
        }
        break;
    default:
      obj["value"] = row.value;
  }
  return obj;
}

function encodeActionValue(row) {
  var obj = {};
  var valueType = ImportEnrichmentRuleTypes$ReactHooksTemplate.valueTypeToString(row.valueType);
  obj["type"] = valueType;
  var match = row.valueType;
  switch (match) {
    case "Literal" :
        obj["value"] = row.valueLiteral;
        break;
    case "CopyPath" :
        obj["path"] = row.copyPath;
        break;
    case "LookupTable" :
        obj["path"] = row.lookupPath;
        obj["map"] = parseLookupMap(row.lookupMapText);
        if (row.lookupDefault !== "") {
          obj["default"] = row.lookupDefault;
        }
        break;
    case "RegexCapture" :
        var pattern = ImportEnrichmentActionHelpers$ReactHooksTemplate.compileExtractPattern(row);
        var caseSensitive = row.regexCaseSensitive;
        obj["path"] = row.regexPath;
        obj["pattern"] = pattern;
        obj["group"] = Caml_format.float_of_string(row.regexGroup);
        if (!caseSensitive) {
          obj["case_sensitive"] = false;
        }
        break;
    case "DateDiffDays" :
        obj["from"] = row.fromPath;
        obj["to"] = row.toPath;
        break;
    case "Template" :
        obj["template"] = row.templateText;
        break;
    
  }
  return obj;
}

function encodeAction(row) {
  var target = {};
  target["kind"] = row.targetKind;
  if (row.targetKind === "more_details") {
    target["key"] = row.targetField;
  } else {
    target["name"] = row.targetField;
  }
  var obj = {};
  obj["id"] = row.id;
  obj["target"] = target;
  obj["value"] = encodeActionValue(row);
  obj["only_if_blank"] = row.onlyIfBlank;
  return obj;
}

function buildDefinitionJson(mode, conditions, actions) {
  var root = {};
  root["version"] = 1.0;
  var conditionJson = Belt_List.toArray(Belt_List.map(Belt_List.keep(conditions, ImportEnrichmentRuleValidation$ReactHooksTemplate.isConditionValid), encodeCondition));
  if (conditionJson.length !== 0) {
    var whenObj = {};
    whenObj["id"] = "g_root";
    if (mode === "All") {
      whenObj["all"] = conditionJson;
    } else {
      whenObj["any"] = conditionJson;
    }
    root["when"] = whenObj;
  }
  root["actions"] = Belt_List.toArray(Belt_List.map(actions, encodeAction));
  return root;
}

exports.decodeObject = decodeObject;
exports.getString = getString;
exports.getBool = getBool;
exports.parseConditionRow = parseConditionRow;
exports.serializeLookupMap = serializeLookupMap;
exports.parseActionRow = parseActionRow;
exports.parseDefinitionForForm = parseDefinitionForForm;
exports.parseLookupMap = parseLookupMap;
exports.encodeCondition = encodeCondition;
exports.encodeActionValue = encodeActionValue;
exports.encodeAction = encodeAction;
exports.buildDefinitionJson = buildDefinitionJson;
/* ImportEnrichmentRuleTypes-ReactHooksTemplate Not a pure module */
